import { render, staticRenderFns } from "./CuringRuleForm.vue?vue&type=template&id=10667954&scoped=true&"
import script from "./CuringRuleForm.vue?vue&type=script&lang=js&"
export * from "./CuringRuleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10667954",
  null
  
)

export default component.exports